import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import React from 'react';
import { useSelector } from 'react-redux';
export function useSystemRoleList(request) {
    const { systemRoleMap } = useSelector(getSettings);
    const systemRoleRow = React.useMemo(() => {
        return Object.entries(systemRoleMap)
            .map(([value, role]) => ({
            id: value,
            value: value,
            label: role.label,
        }))
            .filter(({ value }) => value !== 'system-admin');
    }, [systemRoleMap]);
    const sortedSystemRoleRows = React.useMemo(() => {
        const sortKey = request.sortColumnKey;
        if (sortKey !== 'label') {
            return systemRoleRow;
        }
        return [...systemRoleRow].sort((a, b) => request.sortColumnDesc ? b[sortKey].localeCompare(a[sortKey]) : a[sortKey].localeCompare(b[sortKey]));
    }, [systemRoleRow, request.sortColumnDesc, request.sortColumnKey]);
    const paginatedSystemRoleRows = React.useMemo(() => {
        var _a, _b;
        const offset = (_a = request.offset) !== null && _a !== void 0 ? _a : 0;
        const limit = (_b = request.limit) !== null && _b !== void 0 ? _b : sortedSystemRoleRows.length;
        return sortedSystemRoleRows.slice(offset, offset + limit);
    }, [sortedSystemRoleRows, request.offset, request.limit]);
    const data = {
        rows: paginatedSystemRoleRows,
        filteredRowCount: sortedSystemRoleRows.length,
    };
    return { data, reload: () => { } };
}
